import { useTranslation } from "react-i18next";
import { ScrollText } from "lucide-react";
import { Alert, Card, CardContent, EmptyState } from "@dosa/ui";

/**
 * The local demo mode has no server, so there is no real audit trail to show — audit_logs
 * (database/migrations/0010_files_notifications_audit.sql) is populated by apps/worker on
 * every authorized read/write in production. This page renders the real, empty-state UI a
 * fresh environment would show rather than fabricating log entries client-side.
 */
export function AdminAuditLogsPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.auditLogs.title")}</h1>
      <Alert variant="info">
        Audit logs are written server-side by apps/worker on every authorized action. This local demo has no server, so none
        are shown here — see docs/SECURITY.md.
      </Alert>
      <Card>
        <CardContent className="p-0">
          <EmptyState className="border-0" icon={<ScrollText className="h-8 w-8" />} title={t("common.noResults")} />
        </CardContent>
      </Card>
    </div>
  );
}
